import localStorageHelper from './localStorageHelper'
import localStorageIds from '../constants/localStorageIds'
import SUBSCRIPTION_STATES from '../constants/subscriptionStates'

const orgIsInSubscriptionState = (subscriptionsAllowed, orgId, status) => {
  const searchForInactive =
    subscriptionsAllowed.length === 1 && subscriptionsAllowed?.[0] === SUBSCRIPTION_STATES.INACTIVE

  const { localStorageValue: selectedOrg } = localStorageHelper(localStorageIds.SELECTED_ORG)
  const { localStorageValue: selectedOrgSubStatus } = localStorageHelper(
    localStorageIds.SELECTED_ORG_SUB_STATUS,
  )

  if (!(orgId || selectedOrg?.id)) return false
  if (!selectedOrgSubStatus) return searchForInactive

  return subscriptionsAllowed.includes(status || selectedOrgSubStatus)
}

export default orgIsInSubscriptionState
